import { AllowedAction } from 'api';
import {
	API_ERROR,
	UPDATE_USER_ROLE,
	UPDATE_USER_ROLE_SUCCESS,
	SIGNUP_USER,
	SIGNUP_USER_SUCCESS,
	SIGNUP_INIT,
	GET_ALLOWED_ACTIONS,
	SET_ALLOWED_ACTIONS
} from './actionTypes';

export const signupUserInit = () => {
	return {
		type: SIGNUP_INIT
	};
};

export const signupUser = (user: any) => {
	return {
		type: SIGNUP_USER,
		payload: user
	};
};

export const signupUserSuccess = (user: any) => {
	return {
		type: SIGNUP_USER_SUCCESS,
		payload: user
	};
};

export const apiError = (error: any) => {
	return {
		type: API_ERROR,
		payload: error
	};
};

export const updateUserRole = (role: any) => {
	return {
		type: UPDATE_USER_ROLE,
		payload: role
	};
};

export const updateUserRoleSuccess = (role: any) => {
	return {
		type: UPDATE_USER_ROLE_SUCCESS,
		payload: role
	};
};

export const getAllowedActions = () => {
	return {
		type: GET_ALLOWED_ACTIONS
	};
};

export const setAllowedActions = (allowedActions: AllowedAction[]) => {
	return {
		type: SET_ALLOWED_ACTIONS,
		payload: allowedActions
	};
};
